import React, { useEffect, useState } from "react";
import styles from "./EditorPage.module.css";
import TopBar from "../components/editorPage/EditorPageTopBar/TopBar";
import EditorContainer from "../components/editorPage/EditorContainer/EditorContainer";
import { connect } from "react-redux";
import { getSlides, getSlidesMetaData } from "../helpers/api";
import { updateSlidesMetaData } from "../store/actions/updateSlidesMetaData";
import {
	updateSlides,
	updateActiveSlide,
} from "../store/actions/updateSlideList";
import { updateLastSaved } from "../store/actions/updateAutoSave";
import { UndoRedo } from "../helpers/undoRedo";
import { useParams } from "react-router-dom";
import Routes from "../routes.json";
import CudyLoader from "../components/reusable/Loader/CudyLoader";
import ErrorIcon from "./../assets/404.svg";

const EditorPage = (props) => {
	let params = useParams();

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		UndoRedo.reset();
		fetchSlidesMetaData();
		window.addEventListener("beforeunload", handleUnload);
		return () => {
			window.removeEventListener("beforeunload", handleUnload);
		};
	}, []);

	const handleUnload = (e) => {
		e.preventDefault();
		e.returnValue = "Are you sure that you want to leave this page?";
	};

	const fetchSlidesMetaData = async () => {
		try {
			let data = await getSlidesMetaData(params.id);
			if (data) {
				fetchSlides();
				props.updateSlidesMetaData({
					title: data.title,
					shareLink: data.shareLink,
					shareOption: data.shareOption,
					accessCode: data.accessCode,
					link:
						"https://" +
						window.location.hostname +
						Routes.ViewPage +
						"/" +
						data.id,
					id: data.id,
				});
				props.updateLastSaved({ lastSaved: data.edited });
			} else {
				setError(true);
			}
		} catch (error) {
			setError(true);
		}
	};

	const fetchSlides = async () => {
		try {
			let data = await getSlides(params.id);
			if (data) {
				props.updateSlides({ slides: [...data.slides] });
				props.updateActiveSlide({ activeSlide: 0 });
				if (data.slides[0]) UndoRedo.updateActiveSlide(data.slides[0]);
				setLoading(false);
			} else {
				setError(true);
			}
		} catch (error) {
			setError(true);
		}
	};

	if (loading && !error) {
		return (
			<div className={styles.loader}>
				<CudyLoader />
			</div>
		);
	}

	if (error) {
		return (
			<div className={styles.loader}>
				<img src={ErrorIcon} alt="404" width="420" height="500" />
			</div>
		);
	}

	return (
		<div className={styles.editorPage}>
			<TopBar />
			<EditorContainer />
		</div>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlidesMetaData: (payload) => dispatch(updateSlidesMetaData(payload)),
	updateSlides: (payload) => dispatch(updateSlides(payload)),
	updateActiveSlide: (payload) => dispatch(updateActiveSlide(payload)),
	updateLastSaved: (payload) => dispatch(updateLastSaved(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorPage);
